import styled from "styled-components";
import { useState, useEffect } from "react";
import { ButtonIcon } from ".";
import { ChevronLeft, ChevronRight } from "../icons";
import { BannerAPI } from "@api";

const Container = styled.div`
  border-radius: 0 0 0 5em;
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  @media (max-width: 576px) {
    border-radius: 0;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Navigation = styled.div``;
const NavigationIndicator = styled.div`
  padding-top: 2em;
  display: grid;
  grid-gap: 5%;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  width: 20%;
`;
const IndicatorSelected = styled.div`
  height: 0.25em;
  background: white;
  border-radius: 1em;
  grid-column: ${(props) => props.col + "/ span 2"};
  grid-row: ${(props) => props.row};
`;
const IndicatorUnselected = styled.div`
  height: 0.25em;
  background: white;
  border-radius: 1em;
  opacity: 0.5;
  grid-column: ${(props) => props.col};
  grid-row: ${(props) => props.row};
`;

const Content = styled.div`
  color: white;
  position: absolute;
  right: 2em;
  left: 2em;
  bottom: 4em;
  text-align: left;
  z-index: 2;
`;

const Gradient = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #6c6b6b, #00000054);
  position: absolute;
`;

const Title = styled.h3`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Subtitle = styled.small`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const CarouselAds = () => {
  const [index, setIndex] = useState(0);
  const [banner, setBanner] = useState([]);

  useEffect(() => {
    async function loadData() {
      if (banner.length < 1) {
        const bannerData = await BannerAPI({ loc: "home_main" });
        setBanner(bannerData.data.data);
      }
    }

    loadData();
  }, [banner]);

  const next = () => {
    setIndex((index + 1) % banner.length);
  };

  const previous = () => {
    if (index === 0) {
      setIndex(banner.length - 1);
      return;
    }
    setIndex((index - 1) % banner.length);
  };

  const BannerTitle = () => {
    const defaultValue = "No Title";
    return banner.length > 0
      ? !banner[index]?.title
        ? defaultValue
        : banner[index].title
      : defaultValue;
  };

  const BannerDescription = () => {
    const defaultValue = "No Description";
    return banner.length > 0
      ? !banner[index]?.description
        ? defaultValue
        : banner[index].description
      : defaultValue;
  };

  const BannerImageURL = () => {
    const defaultValue =
      "https://dummyimage.com/1080x720/cccccc/000000&text=++No+Image++";
    return banner.length > 0
      ? !banner[index]?.image
        ? defaultValue
        : banner[index].image
      : defaultValue;
  };

  return (
    <Container>
      <Content>
        <Navigation>
          <ButtonIcon
            height="2em"
            width="2em"
            m="0.25em 0.25em 0.25em 0"
            onClick={previous}
          >
            <ChevronLeft fill="#000" />
          </ButtonIcon>

          <ButtonIcon height="2em" width="2em" m="0.25em" onClick={next}>
            <ChevronRight fill="#000" />
          </ButtonIcon>
        </Navigation>
        <Title>
          <BannerTitle />
        </Title>
        <Subtitle>
          <BannerDescription />
        </Subtitle>

        <NavigationIndicator>
          {banner.map((data, i) => {
            if (index === i) {
              return <IndicatorSelected col={i + 1} key={i} />;
            } else {
              return <IndicatorUnselected key={i} />;
            }
          })}
        </NavigationIndicator>
      </Content>
      <Gradient />
      <Image src={BannerImageURL()} loading="lazy" />
    </Container>
  );
};

export default CarouselAds;
